module.exports = __webpack_public_path__ + "img/docRes_d.60724da5.png";